export var ActorType = /* @__PURE__ */ ((ActorType2) => {
  ActorType2["ON_CHILD_ATTRIBUTE_UPDATE"] = "onChildAttributeUpdate";
  ActorType2["ON_SCENE_RESET"] = "onSceneReset";
  ActorType2["ON_SCENE_PLAY_STATE"] = "onScenePlayState";
  ActorType2["ON_TICK"] = "onTick";
  ActorType2["ON_OBJECT_ATTRIBUTE_UPDATE"] = "onObjectAttributeUpdate";
  ActorType2["ON_OBJECT_CLICK"] = "onObjectClick";
  ActorType2["ON_OBJECT_HOVER"] = "onObjectHover";
  ActorType2["ON_OBJECT_POINTER_DOWN"] = "onObjectPointerDown";
  ActorType2["ON_OBJECT_POINTER_UP"] = "onObjectPointerUp";
  ActorType2["ON_POINTER_UP"] = "onPointerUp";
  ActorType2["RAY_FROM_CURSOR"] = "rayFromCursor";
  return ActorType2;
})(ActorType || {});
